.root {
  .radio {
    border: 1.5px solid var(--mantine-color-tertiary-7);
    background-color: var(--mantine-color-white);

    &:checked:not(:disabled) {
      border-color: var(--mantine-color-green-5);
      background-color: var(--mantine-color-green-5);
    }

    &:disabled {
      border: none;
    }
  }
}
